import { collections } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CollectionsIndex() {
  return (
    <section id="collections" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              label="Index"
              title="合集索引：一个入口看完整套"
              desc="像翻目录一样找瓜，黑料网吃瓜合集把同类事件归到一处，按主题一次看够。"
            />
            <span className="text-sm text-foreground-500 whitespace-nowrap">共 6 个合集 · 持续增补</span>
          </div>

          <div className="mt-8 md:mt-10 rounded-lg border border-background-200 bg-background-100 overflow-hidden">
            {collections.map((collection, index) => (
              <a
                key={collection.no}
                href="#covers"
                className={`group grid grid-cols-[auto_1fr_auto] items-center gap-4 md:gap-6 px-4 md:px-6 py-5 cursor-pointer transition-colors hover:bg-accent-50 ${
                  index !== 0 ? "border-t border-background-200" : ""
                }`}
              >
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-400 group-hover:text-accent-600 transition-colors w-10 md:w-14 tabular-nums">
                  {collection.no}
                </span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {collection.title}
                    </h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                      {collection.count}
                    </span>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{collection.desc}</p>
                  <div className="flex flex-wrap gap-2 mt-2.5">
                    {collection.tags.map((tag) => (
                      <span key={tag} className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <i className="ri-arrow-right-line text-lg text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}